module.exports = __webpack_public_path__ + "static/media/linkedin.0a46be51.svg";